import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MatchingState } from './models/matching-state.models';

export const selectMatchingState = createFeatureSelector<MatchingState>('matching');

export const selectMatches = createSelector(
  selectMatchingState,
  (state: MatchingState) => state.matches
);

export const selectShownMatches = createSelector(
  selectMatches,
  (matches) => matches?.shown ?? []
);

export const selectActiveMatches = createSelector(
  selectMatches,
  (matches) => matches?.active ?? []
);

export const selectConnectedMatches = createSelector(
  selectMatches,
  (matches) => matches?.connected ?? []
);

export const selectHistoryMatches = createSelector(
  selectMatches,
  (matches) => matches?.history ?? []
);

export const selectTotalCount = createSelector(
  selectMatches,
  (matches) => matches?.total_count ?? 0
);

export const selectActionableCount = createSelector(
  selectMatches,
  (matches) => matches?.actionable_count ?? 0
);

export const selectMatchesLoading = createSelector(
  selectMatchingState,
  (state: MatchingState) => state.loading
);

export const selectMatchingError = createSelector(
  selectMatchingState,
  (state: MatchingState) => state.error
);
